// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var MenuOption_MenuNavigation;
(function (MenuOption_MenuNavigation) {
    MenuOption_MenuNavigation["BACK"] = "BACK";
    MenuOption_MenuNavigation["TOP"] = "TOP";
    MenuOption_MenuNavigation["EXIT"] = "EXIT";
    MenuOption_MenuNavigation["REPEAT"] = "REPEAT";
})(MenuOption_MenuNavigation || (MenuOption_MenuNavigation = {}));
export var MenuOption_MenuNavigation_index;
(function (MenuOption_MenuNavigation_index) {
    MenuOption_MenuNavigation_index[MenuOption_MenuNavigation_index["BACK"] = 0] = "BACK";
    MenuOption_MenuNavigation_index[MenuOption_MenuNavigation_index["TOP"] = 1] = "TOP";
    MenuOption_MenuNavigation_index[MenuOption_MenuNavigation_index["EXIT"] = 2] = "EXIT";
    MenuOption_MenuNavigation_index[MenuOption_MenuNavigation_index["REPEAT"] = 3] = "REPEAT";
})(MenuOption_MenuNavigation_index || (MenuOption_MenuNavigation_index = {}));
export const IVRService = {
    /**
     * ListPhoneTree endpoint is calling phone-config-api which is based on monorail proto
     */
    ListPhoneTrees(fn, req) {
        return fn(`/phone-exp/phone-tree/v1/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListPhoneTree V2 endpoint will be using schema
     */
    ListPhoneTreesV2(fn, req) {
        return fn(`/phone-exp/phone-tree/v2/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * PhoneTree method returns details about a phone tree
     */
    PhoneTreeDetails(fn, req) {
        try {
            fm.validateUrlParam(req["ivrMenuId"], "ivrMenuId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/phone-tree/v1/details/${req["ivrMenuId"]}?${fm.renderURLSearchParams(req, ["ivrMenuId"])}`, { method: "GET" });
    },
    CreatePhoneTree(fn, req) {
        return fn(`/phone-exp/phone-tree/v1`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdatePhoneTree(fn, req) {
        try {
            fm.validateUrlParam(req["ivrMenuId"], "ivrMenuId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-exp/phone-tree/v1/${req["ivrMenuId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * UpdateExtension Dialing Option for a phone tree
     */
    UpdateExtension(fn, req) {
        return fn(`/phone-exp/phone-tree/v1/extension-dialing`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
};
